"use client";

import { DataTable } from "@/components/tool-kit/primitives";
import { LABEL } from "@/components/tool-kit/styles";
import {
  formatSig,
  type NumberFormatter,
} from "@/lib/tool-kit/physics-mechanics/format";
import {
  ENERGY,
  fromBase,
  type UnitFamily,
  unitSymbol,
} from "@/lib/tool-kit/physics-mechanics/units";

/** The same quantity in a chosen list of units from one family. */
export function UnitEquivalents({
  value,
  family,
  unitIds,
  heading,
  columnUnit,
  columnValue,
  fmt,
  sig,
}: {
  /** The quantity in the family's SI base unit. */
  value: number;
  family: UnitFamily;
  unitIds: readonly string[];
  heading: string;
  columnUnit: string;
  columnValue: string;
  fmt: NumberFormatter;
  sig: number;
}) {
  return (
    <div className="space-y-2">
      <p className={LABEL}>{heading}</p>
      <DataTable
        head={[columnUnit, columnValue]}
        rows={unitIds.map((id) => [
          unitSymbol(family, id),
          formatSig(fmt, fromBase(value, family, id), sig),
        ])}
      />
    </div>
  );
}

/** The same energy in the units a reader may need next. */
export function EnergyEquivalents({
  joules,
  ...rest
}: {
  joules: number;
  unitIds: readonly string[];
  heading: string;
  columnUnit: string;
  columnValue: string;
  fmt: NumberFormatter;
  sig: number;
}) {
  return <UnitEquivalents family={ENERGY} value={joules} {...rest} />;
}
